import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { UserListHead } from 'src/sections/@dashboard/user';

const DraftPostGridHead = ({ draftList, order, orderBy, handleRequestSort }) => {
  const { t: translate } = useTranslation();
  const getTableDesk = [
    { id: 'created_time', label: translate('draft.created_at'), alignRight: false, hasSort: true },
    { id: 'description', label: translate('draft.draft_content'), alignRight: false, hasSort: true },
    { id: 'media', label: translate('draft.media'), alignRight: false },
    { id: 'created_by_name', label: translate('draft.created_by'), alignRight: false, hasSort: true },
    { id: 'scheduled-for', label: translate('draft.draft_for'), alignRight: false },
    { id: 'action', label: translate('common.action'), alignRight: false },
  ];
  const getTableMobile = [
    { id: 'created_time', label: translate('draft.created_at'), alignRight: false, hasSort: true },
    { id: 'description', label: translate('draft.draft_content'), alignRight: false, hasSort: true },
    { id: 'action', label: translate('common.action'), alignRight: false },
  ];
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const TABLE_HEAD = isMobile ? getTableMobile : getTableDesk;

  return (
    <UserListHead
      order={order}
      orderBy={orderBy}
      headLabel={TABLE_HEAD}
      rowCount={draftList.length}
      onRequestSort={handleRequestSort}
      style={{ whiteSpace: 'nowrap' }}
      isShowCheckbox={false}
    />
  );
};

export default DraftPostGridHead;
